export const EVENT_PET = {
  INSURANCE_SUBMITTED: 'pet-insurance_submitted',
  BUSY: 'pet_busy',
  ENTERED: 'pet-entered',
  ERROR: 'pet-error',
  REENTRY_LOADED: 'pet-reentry_loaded',
  SYNC_EXECUTED: 'pet-sync_executed',
  GOTO_SANITAS: 'pet-goto-sanitas',
  NEW_PET_LEAD: 'pet-new_pet_lead',
  SELECTED: 'pet-selected'
}

export const EVENT_LEAD = {
  CREATED: 'pet-lead_created',
  OPEN: 'pet-lead_open',
  CLOSE: 'pet-lead_close',
  SAVED: 'pet-lead_saved',
  UPDATED: 'pet-lead_updated',
  REJECTED: 'pet-lead_rejected',
  TRACK_AFTER_UPDATE: 'pet-lead_track_after_update',
  DEDUCTIBLE_ADJUSTED: 'pet-lead_deductible_adjusted',
  HEALTH_ANSWERS_CLEARED: 'pet-lead_health_answers_cleared',
  HEALTH_QUESTIONS_EXTENDED: 'pet-lead_health_questions_extended',
  SUMMARY_SENT: 'pet-lead_summary_sent'
}

export const EVENT_FORM = {
  INIT: 'PetFormStarted',
  INTERACTED: 'PetFormInteracted',
  CANCELED: 'PetFormCancelled',
  ERROR: 'PetFormError',
  SUBMITTED: 'PetFormSubmitted',
}

export const EVENT_LANGUAGE = {
  LOADED: 'pet-language_loaded',
  ERRORS_LOADED: 'pet-errors_loaded',
}

export const EVENT_MODAL = {
  OPEN: 'pet-open_modal',
  UPDATE: 'pet-update_modal',
  BEFORE_CLOSING: 'pet-before-closing_modal',
  CLOSE: 'pet-close_modal',
}

export const EVENT_PRODUCT = {
  DEDUCTIBLE_CHANGED: 'pet-deductible_changed',
  ADDED: 'pet-product_added',
}

export const EVENT_SESSION = {
  CLEAR: 'pet-session_cleared',
  RESUME: 'pet-session_resume',
  START: 'pet-session_start',
  UPDATE: 'pet-session_updated',
}

export const SOURCE = {
  BACKEND: 'BACKEND',
  LEAD: 'Lead',
  DEDUCTIBLE: 'Deductible'
}

export const EVENT_TRACKING = {
  CLEAR_HISTORY: 'pet-tracking_clear_history',
  ENTERED: 'pet-tracking_entered',
  ROUTE_CHANGE: 'pet-tracking_route_change',
  SET: 'pet-tracking_manual-set',
}

export const EVENT_URL = {
  PREFILL: 'pet-events_prefill',
  GOTO: 'pet-events_goto',
}

export const CUSTOM_EVENT_SURVEY_TRIGGER = 'sanitas_survey-trigger_event'
export const CUSTOM_EVENT_SURVEY_OPEN = 'sanitas_survey-open_event'
